module.exports = __webpack_public_path__ + "img/advantage1.3d44a314.png";